import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/HomeComponents/Footer.css";
import logo from "../../assets/Images/logo.png";
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa6";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
const [successMessage, setSuccessMessage] = useState("");

  // const handleSubscribe = async (e) => {
  //   e.preventDefault();
  //   if (!email) return alert("Please enter your email.");
  
  //   const scriptURL = process.env.REACT_APP_SUBSCRIBE_SCRIPT_URL;

  
  //   // Prepare data as URL-encoded form data
  //   const formBody = new URLSearchParams();
  //   formBody.append('email', email);
  
  //   try {
  //     const res = await fetch(scriptURL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //       body: formBody.toString(),
  //     });
  
  //     const result = await res.json();
  
  //     if (result.status === "success") {
  //       alert("Subscribed successfully!");
  //       setEmail("");
  //     } else {
  //       alert("Error: " + result.message);
  //     }
  
  //   } catch (err) {
  //     alert("Subscription failed. Please try again.");
  //     console.error("Error:", err);
  //   }
  // };


  const handleSubscribe = async (e) => {
  e.preventDefault();
  if (!email) return;

  setIsSubmitting(true);
  setSuccessMessage("");

  const scriptURL = process.env.REACT_APP_SUBSCRIBE_SCRIPT_URL;

  const formBody = new URLSearchParams();
  formBody.append("email", email);

  try {
    const res = await fetch(scriptURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody.toString(),
    });

    const result = await res.json();

    if (result.status === "success") {
      setSuccessMessage("Successfully subscribed!");
      setEmail("");

      setTimeout(() => {
        setSuccessMessage("");
      }, 4000);
    } else {
      setSuccessMessage("Something went wrong. Please try again.");
    }
  } catch (err) {
    setSuccessMessage("Subscription failed. Please try again.");
  }

  setIsSubmitting(false);
};

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-column logo-column">
          <Link to="/">
  <img src={logo} alt="Strawket Logo" className="footer-logo" />
</Link>
        </div>
        <div className="footer-column ">
          <h4>Address</h4>
          <ul>
            <li>Strawket Learning Inc.</li>
            <li>Ontario, Canada</li>
          </ul>
        </div>

        <div className="footer-column ">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            {/* <li>
              <Link to="/students">For Students</Link>
            </li> */}
            <li>
              <Link to="/academies">For Academies</Link>
            </li>
            <li>
              <Link to="/pricing">Pricing</Link>
            </li>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/blog">Blog Posts</Link>
            </li>
          </ul>
        </div>

        <div className="footer-column subscribe-column">
          <h4>
            Stay up to date with our news,
            <br />
            ideas and updates
          </h4>
          <form className="subscribe" onSubmit={handleSubscribe}>
            <input
              type="email"
              name="email"
              placeholder="Your email here"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="s-email"
            />
            <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Submitting..." : "Get Inspired"}
</button>
          </form>

        {successMessage && (
  <div className="footer-success-popup">
    {successMessage}
  </div>
)}

          <div className="social-icons">
            <a
              href={process.env.REACT_APP_FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
            <a
              href={process.env.REACT_APP_INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href={process.env.REACT_APP_YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>
            <a
              href={process.env.REACT_APP_LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-conditions">Terms of Service</Link>
      </div>
    </footer>
  );
};

export default Footer;
